import {Component, Input, OnInit} from '@angular/core';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {FormModel, FormState} from '../../../common/components/form/models';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';

@Component({
  selector: 'app-url-form',
  templateUrl: './url-form.component.html',
  styleUrls: ['./url-form.component.scss']
})
export class UrlFormComponent implements OnInit {
  @Input() form: FormModel;
  formState = FormState;
  constructor(private snackSvc: SnackBarToastyService,
              public formulaireSvc: FormulaireService) { }

  ngOnInit(): void {
  }
  linkCopied(copied) {
    if (copied) {
      this.snackSvc.toasty('Lien', 'Le lien a été copié, vous pouvez le coller où vous le souhaitez', typeToast.success);
    } else {
      this.snackSvc.toasty('Lien', `Le lien n'a pas été copié, copier le lien manuellement`, typeToast.error);
    }
  }
}
